import { render, staticRenderFns } from "./activityUser.vue?vue&type=template&id=20608e50&scoped=true&"
import script from "./activityUser.vue?vue&type=script&lang=js&"
export * from "./activityUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20608e50",
  null
  
)

export default component.exports